import { QUESTION_TYPE } from '../modules/entity/subEntities/audit/constants';

export const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';
export const API_URL = process.env.REACT_APP_PUBLIC_URL_BASE;
export const BO_URL = process.env.REACT_APP_BO_PUBLIC_URL;

export const CONTROL_REPORT_ALLOWED_TYPES = [
  QUESTION_TYPE.CHECKBOX,
  QUESTION_TYPE.SEVERITY,
  QUESTION_TYPE.THICKNESS,
  QUESTION_TYPE.EXPLODED_VIEW,
  QUESTION_TYPE.PADS_THICKNESS,
  QUESTION_TYPE.NUMBER,
  QUESTION_TYPE.RADIO_BUTTON,
  QUESTION_TYPE.DATE_TIME,
  QUESTION_TYPE.TIRE_REPORT,
];

export const CIVILITY = {
  MISS: 'MISS',
  MR: 'MR',
  MS: 'MS',
  COMPANY: 'COMPANY',
  NONE: 'NONE',
};
export const MULTI_BRAND_NAME = 'Multi Brand';

export const MEDIA_TYPES = {
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  IMAGE_INSIDE_360: 'IMAGE_INSIDE_360',
  VIDEO: 'VIDEO',
  VIDEO_360: 'VIDEO_360',
};

export const MEDIA_STATUS = {
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
};

export const MEDIA_ACCESS_CONTROLS = {
  PUBLIC: 'PUBLIC',
  USER: 'USER',
};

export const USER_TYPE = {
  DEVICE: 'DEVICE',
  SYSTEM: 'SYSTEM',
  USER: 'USER',
};

export const SIGNATURE_STATUS = {
  SIGNED: 'SIGNED',
  UNSIGNED: 'UNSIGNED'
};

export const RETRY_NUMBER_TIMES = 10;
export const INVISIBLE_CHARACTER = '\uFEFF';

export const EXPIRED_ERROR = 410;

export const POLICY_TYPES = {
  GENERAL_TERMS_CONDITION: 'GENERAL_TERMS_CONDITION',
  CONFIDENTIALITY_POLICY: 'CONFIDENTIALITY_POLICY',
};

export const EMPTY_TRANSLATION = ' ';

export const FLEETBACK = 'Fleetback';
export const FLEETBACK_ICON = '/fleetback-icon.ico';

export const DEFAULT_CURRENCY = '€';
export const DEFAULT_CURRENCY_ISO = 'xxx';

export const PREVIEW_URL = 'PREVIEW';

export const FONT_ICON_URL = `${process.env.REACT_APP_ASSETS_URL}/public/themes/default/font-icons/fb-icon.css`;

export const IMAGES_URL = `${process.env.REACT_APP_ASSETS_URL}/public/themes/default/images`;
